
import XHeader from 'vux/src/components/x-header/index.vue'

import { mapState, mapGetters } from 'vuex';

export default {
components: { XHeader },
data() {
return {
isShow: true,
title: '',

showBack:true,

showPayRecord: false,
rightSlotStyle: {
textDecoration: 'none',
color: '#766864'
},
text: '',
toName: ''
};
},
computed: {
...mapState({
vuexTitle: state => state.header.title,
userInfo: state => state.user.userInfo
}),
...mapGetters({

isParentUnShield: 'isParentUnShield'
})
},
methods: {
handleBack() {
if (this.$route.query.isFromTrial) {
this.$router.replace({name: 'bindPhone', query: this.$route.query})
} else {
this.$router.replace({ name: 'reportList', query: this.$route.query });
}
}
},
watch: {
$route(newRoute) {
this.isShow = !newRoute.meta.hideHeader;
this.title = '' || newRoute.meta.title;
this.showPayRecord = newRoute.meta.showPayRecord || false;
if (newRoute.name === 'reportList') {
this.text = '历次考试';
this.toName = 'reportHistory';
} else if (newRoute.name === 'reportDetail' && this.userInfo.roleType == 2 && this.isParentUnShield) {
this.text = '购买记录';
this.toName = 'payRecord';
}
if(newRoute.name === 'reportList'){
this.showBack = false;
}else{
this.showBack = true;
}
},
vuexTitle(nv) {
this.title = nv || this.$route.meta.title;
}
}
};



// WEBPACK FOOTER //
// ./src/views/ReportApp/components/AppHeader.vue